module.exports = __webpack_public_path__ + "lemon_vue/img/pay04.7211359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pay04.png
// module id = rLdS
// module chunks = 1